import { PROVIDER_IDS } from 'app/domains/esigning/utils';
import { EsigningProviderAuthenticationModeSlug } from 'shared/domains/apollo/generated/types';
export const getEsigningProviderMetadataByProviderId = (id) => {
    switch (id) {
        case PROVIDER_IDS.DOCUSIGN: {
            return {
                properties: {
                    nameFormat: 'fullName',
                    showActiveSignRequestHistory: false,
                    showCreditBalance: false,
                    isRecommended: false,
                    hasExternalAPI: true,
                    selectedByDefault: false,
                    canRemoveSignatory: true,
                    canUseSigningOrder: false,
                    canUseApprovers: false,
                    canUseTitleField: false,
                    canUseEsigningMessages: false,
                    canUseAutomaticReminder: false,
                    canUseEditPendingSignatory: false,
                    maxNumberOfAttachments: null,
                    defaultAuthenticationMode: EsigningProviderAuthenticationModeSlug.Email,
                    advancedAuthenticationModes: [],
                    selectOrder: 3,
                    hasSettings: false,
                    allowDuplicateEmails: false,
                    canUseCustomSignaturePosition: false,
                    canEditPendingViewer: false,
                    canGenerateEsignUrl: false,
                },
            };
        }
        case PROVIDER_IDS.IDURA: {
            return {
                properties: {
                    nameFormat: 'firstNameLastName',
                    showActiveSignRequestHistory: true,
                    showCreditBalance: true,
                    isRecommended: true,
                    hasExternalAPI: false,
                    selectedByDefault: true,
                    canRemoveSignatory: true,
                    canUseSigningOrder: true,
                    canUseApprovers: true,
                    canUseTitleField: true,
                    canUseEsigningMessages: true,
                    canUseAutomaticReminder: true,
                    canUseEditPendingSignatory: true,
                    maxNumberOfAttachments: 20,
                    defaultAuthenticationMode: EsigningProviderAuthenticationModeSlug.Email,
                    advancedAuthenticationModes: [EsigningProviderAuthenticationModeSlug.SweBankid],
                    selectOrder: 1,
                    hasSettings: true,
                    allowDuplicateEmails: true,
                    canUseCustomSignaturePosition: true,
                    canEditPendingViewer: true,
                    canGenerateEsignUrl: true,
                },
            };
        }
        default: {
            return {
                properties: {
                    nameFormat: 'fullName',
                    showActiveSignRequestHistory: false,
                    showCreditBalance: false,
                    isRecommended: false,
                    hasExternalAPI: false,
                    selectedByDefault: false,
                    canRemoveSignatory: false,
                    canUseSigningOrder: false,
                    canUseApprovers: false,
                    canUseTitleField: false,
                    canUseEsigningMessages: false,
                    canUseAutomaticReminder: false,
                    canUseEditPendingSignatory: false,
                    maxNumberOfAttachments: null,
                    defaultAuthenticationMode: EsigningProviderAuthenticationModeSlug.Email,
                    advancedAuthenticationModes: [],
                    selectOrder: 999,
                    hasSettings: false,
                    allowDuplicateEmails: false,
                    canUseCustomSignaturePosition: false,
                    canEditPendingViewer: false,
                    canGenerateEsignUrl: false,
                },
            };
        }
    }
};
